var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaneTakeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 27,
    viewBox: "0 0 37 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2654 22.6855H0.904399C0.404807 22.6855 0.00016065 23.0759 0.00016065 23.558V25.303C0.00016065 25.785 0.404807 26.1755 0.904399 26.1755H35.2654C35.765 26.1755 36.1697 25.785 36.1697 25.303V23.558C36.1697 23.0759 35.765 22.6855 35.2654 22.6855ZM4.55243 16.8653C4.90735 17.2383 5.40581 17.4499 5.92744 17.4494L13.3049 17.4395C13.8871 17.4388 14.461 17.3058 14.98 17.0513L31.4236 8.99971C32.9348 8.25972 34.2894 7.20345 35.2112 5.81999C36.246 4.26693 36.3584 3.14304 35.9498 2.34906C35.5424 1.55454 34.5517 0.971052 32.6579 0.852174C30.9709 0.746383 29.293 1.175 27.7817 1.91445L22.2145 4.64047L9.85466 0.165623C9.70605 0.0690251 9.5334 0.0124821 9.35456 0.00184052C9.17572 -0.00880106 8.99717 0.026845 8.83739 0.105093L5.12154 1.92481C4.51853 2.21982 4.37272 2.99635 4.82936 3.48059L13.6581 8.83012L7.82521 11.6865L3.73636 9.69771C3.59549 9.62918 3.43989 9.59358 3.28213 9.59376C3.12437 9.59395 2.96886 9.62994 2.82817 9.6988L0.560223 10.8096C-0.0297922 11.0986 -0.185208 11.8522 0.245435 12.3409L4.55243 16.8653Z",
    fill: "#E53238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneTakeOff);
export default __webpack_public_path__ + "static/media/plane_take_off.e8f846caf42d52274851bcb3b497bc2a.svg";
export { ForwardRef as ReactComponent };